import { render, staticRenderFns } from "./customers0608-add-or-update.vue?vue&type=template&id=1940a21d&"
import script from "./customers0608-add-or-update.vue?vue&type=script&lang=js&"
export * from "./customers0608-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports